import { Grid, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import './Orders.scss';
import { useTranslation } from 'react-i18next';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import TabPanel from '../common/ui/TabPanel';
import { ArchivedOrders } from './ArchivedOrders';
import { AllOrders } from './AllOrders';
import { mb } from '../common/theme/mbTokens';

const Orders = () => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Grid container direction="column" flexWrap="nowrap" sx={{ flex: 1, minHeight: 0 }}>
      <HelmetProvider>
        <Helmet>
          <title>Monkeybook - {t('main_sidebar.orders')}</title>
        </Helmet>
      </HelmetProvider>

      <Grid item sx={{ px: mb.layout.cardPadding, pt: mb.layout.cardPadding }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={t('orders.orders')} />
          <Tab label={t('orders.archived')} />
        </Tabs>
      </Grid>

      <Grid item sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <TabPanel value={value} index={0}>
          <AllOrders />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ArchivedOrders />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default Orders;
